import React from 'react'
import AutoComplete from 'material-ui/AutoComplete'
import TextField from 'material-ui/TextField'
import ScannedTextList from './ScannedTextList'

const SerialField = ({
  serials,
  serial,
  handleScanned,
  scannedText,
  handleFieldChange,
  gotScannedText,
  handleUpdateInput,
  mode
}) => {
  return (
    <div>
      {serials && (
        <AutoComplete
          floatingLabelText={
            mode === 'Legacy'
              ? 'Serial Number (xxxx-xxxx-xxxx)'
              : 'Serial Number'
          }
          searchText={serial || ''}
          openOnFocus={true}
          onUpdateInput={handleUpdateInput}
          filter={AutoComplete.caseInsensitiveFilter}
          dataSource={serials}
        />
      )}
      {!serials && (
        <TextField
          floatingLabelText={
            mode === 'Legacy'
              ? 'Serial Number (xxxx-xxxx-xxxx)'
              : 'Serial Number'
          }
          value={serial}
          onChange={handleFieldChange}
        />
      )}
      {gotScannedText && (
        <ScannedTextList
          handleChange={handleScanned}
          scannedText={scannedText}
        />
      )}
    </div>
  )
}

export default SerialField



// WEBPACK FOOTER //
// ./src/components/SerialField.js